module.exports = __webpack_public_path__ + "static/media/un-soda.02e5521b.png";